/* eslint-env browser, es6 */
import m from "mithril";

import {plural} from "../utils";

export class PausedMessageView implements m.Component {
  view(): m.Children {
    return m("div.post-board", "(paused)");
  }
}

interface ScoreMessageViewAttrs {
  score: number;
  maxScore: number;
}

export class ScoreMessageView implements m.Component<ScoreMessageViewAttrs> {
  private score: number;
  private maxScore: number;

  constructor(vnode: m.Vnode<ScoreMessageViewAttrs>) {
    this.score = vnode.attrs.score;
    this.maxScore = vnode.attrs.maxScore;
  }

  view(): m.Children {
    return m("div.post-board", [
      "You got ",
      m("strong", `${this.score}`),
      " pts ",
      m("strong", `(${(this.score / this.maxScore * 100).toFixed(1)}%)`),
    ]);
  }
}
